
export default {
  data() {
    return {
      loading: false,
      form: {
        oldPassword: '',
        newPassword: '',
      },
      alertBox: {
        status: false,
        message: '',
        variant: '',
      },
    }
  },
  methods: {
    async SEND_TO_UPDATE_CHANGE_PASSWORD(e) {
      e.preventDefault()
      this.loading = true
      this.alertBox = await this.$store.dispatch(
        'user/SEND_TO_UPDATE_CHANGE_PASSWORD',
        this.form
      )
      this.loading = false
      setTimeout(() => {
        if (this.alertBox.variant === 'success') {
          this.alertBox.status = false
        }
      }, 2500)
    },
  },
}
